import { EntityModel } from '@/interfaces'
import {
  ALL_CURRENCIES_QUERY,
  CREATE_CURRENCY_MUTATION,
  DELETE_CURRENCY_MUTATION,
  FORCE_DELETE_CURRENCY_MUTATION,
  SINGLE_CURRENCY_QUERY,
  UPDATE_CURRENCY_MUTATION,
} from './graphql'

const systemCurrencyModel: EntityModel = {
  name: 'currency',
  namePlural: 'currencies',
  uniqueName: 'systemCurrency',
  uniqueNamePlural: 'systemCurrencies',
  path: 'config/currency',
  baseUrl: '/config/currencies',
  translationPrefix: 'entities:systemCurrency.',
  getDisplayName: (values: any) => {
    return values.code
  },
  gql: {
    getAll: ALL_CURRENCIES_QUERY,
    getSingle: SINGLE_CURRENCY_QUERY,
    create: CREATE_CURRENCY_MUTATION,
    update: UPDATE_CURRENCY_MUTATION,
    delete: DELETE_CURRENCY_MUTATION,
    forceDelete: FORCE_DELETE_CURRENCY_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:systemCurrency.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    symbol: {
      name: 'symbol',
      label: 'entities:systemCurrency.attributes.symbol.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    code: {
      name: 'code',
      label: 'entities:systemCurrency.attributes.code.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    isDefault: {
      name: 'isDefault',
      label: 'entities:systemCurrency.attributes.isDefault.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    exchangeRate: {
      name: 'exchangeRate',
      label: 'entities:systemCurrency.attributes.exchangeRate.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [],
    },
    defaultCountries: {
      name: 'defaultCountries',
      label: 'entities:systemCurrency.attributes.defaultCountries.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'tags',
      validationType: 'string',
      validations: [],
    },
  },
}

export default systemCurrencyModel
